import styles from './offline-files-list.module.scss';
import { GetCurrentCompany } from '../customer-context/customer-context';
import { useGetRequestNewHook } from '../requestUtils';
import WebkuaTable from '../webkua-table/webkua-table';
import { Box, CreateHeaders, dateHeader, HeaderSizeEnum, prettyPrintXML, textHeader } from '@frontend-workspace/react-shared-lib';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface OfflineFilesListProps { }

export function OfflineFilesList(props: OfflineFilesListProps) {
  const { t } = useTranslation();
  const currentCompany = GetCurrentCompany();
  const companyNumber = currentCompany?.number ?? "All";
  const { data } = useGetRequestNewHook(`companies/${companyNumber}/action/getOfflineLicenseFiles`, [], [currentCompany]);

  return (
    <WebkuaTable
      headers={CreateHeaders([
        textHeader("companyNumber", t("standard.companyNo"), HeaderSizeEnum.MEDIUM, { renderer: "agGroupCellRenderer" }),
        textHeader("companyName", t("standard.companyName"), HeaderSizeEnum.EXTRA_LARGE),
        textHeader("createdBy", t("standard.createdBy"), HeaderSizeEnum.EXTRA_LARGE),
        dateHeader("activationDate", t("standard.activated")),
        dateHeader("expirationDate", t("standard.expires")),
        textHeader("licenseNumbers", t("standard.licenseNumber"), HeaderSizeEnum.MEDIUM)
      ])}
      expandComponent={OfflineLicenseDetails}
      data={data}
    />
  );
}

function OfflineLicenseDetails(props: any) {
  return (
    <Box className="d-flex flex-column py-4 px-3">
      <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
        {prettyPrintXML(props.data.xmlString)}
      </pre>
    </Box>

  )
}

export default OfflineFilesList;
